import { Pais } from "../../../../../infraestructure/persistence/rest/PaisesAdapter"

export const createOptions = (data:any) =>{
  return data.map((p: Pais)=> { return { label: p.pais, value: p.codPais } })
}